import { useNavigate, Link } from "@solidjs/router";
import { Offcanvas } from "solid-bootstrap";
import { Component, createSignal, Show } from "solid-js";
import { toQueryString } from "../../API";
import { Notifications } from "../notifications";
import { LanguageSelector } from "../language-selector/index";
import { UserSession } from "../../types";
import { Login } from "../../sections/login";
import { createStore } from "solid-js/store";
import './jetmenu.css'
import './jetmenu-overrides.less'

type SubMenu = "None" | "About Us" | "News" | "Museum" | "Education" | "Community" | "Competitions" | "Store" | "Search" | "My ARC" | "Donate" | "Notifications";

export const JetMenu : Component<any> = (props: any) => {
    const [session, setSession] = createStore<UserSession>({ } as UserSession);
    const navigate = useNavigate();
    const hasPermission = (permission: string) => {
        if (!session.isLoggedIn) return false;
        return session.member?.permissions?.some(p => p == "Everything" || permission == p);
    }
    const [submenu, setSubmenu] = createSignal<SubMenu>("None");
    const [query, setQuery] = createSignal<string>("");
    const clear = () => setSubmenu("None");
    const onSearchSubmit = (e: Event) => {
        const querystring = toQueryString({ query: query() });
        window.location.href = "/Home/SiteSearch?" + querystring;
    };
    const logoutClicked = async (e: Event) => {
        e.preventDefault();
        const response = await fetch("/Forums/User/LogoutJson");
        const json = await response.json();
        if (!json.Success) return;
        setSession({ isLoggedIn: false });
    };
    const loginClicked = (e: Event) => {
        e.preventDefault();
        handleOpenLogin();
    };
    const [showLogin, setShowLogin] = createSignal(false);
    const handleOpenLogin = () => setShowLogin(true);
    const handleCloseLogin = () => setShowLogin(false);
    const onLoginCancel = () => handleCloseLogin();
    const onLoginSuccess = (session: UserSession) => {
        handleCloseLogin();
        setSession(session);
    };
    const onLoginRegistrationRequired = () => {
        handleCloseLogin();
        setSession({
            isLoggedIn: true,
            isRegistered: false
        });
        navigate("/register");
    };
    return (
    <div>
        <div class="navbar-fixed-top salon-navbar">
            <ul class="jetmenu blue">
                <li class="left">
                    <a href="/"><span class="fa fa-home"></span></a>
                </li>
                <li onmouseenter={() => setSubmenu("Search") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Search" }}>
                    <a href="#" style="border-bottom: unset;"><span class="fa fa-search"></span></a>
                    <Show when={submenu() == "Search"}>
                        <div class="megamenu">
                            <div class="megamenu half-width">
                                <div class="row">
                                    <div class="col6">
                                        <form onSubmit={onSearchSubmit}>
                                            <input type="text" placeholder="Type in your query ..." value={query()} onInput={(e) => setQuery(e.currentTarget.value)} />
                                            <input type="submit" value="Search" />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Show>
                </li>
                <li onmouseenter={() => setSubmenu("About Us") } onmouseleave={clear} classList={{ "menu-active": submenu() == "About Us" }}>
                    <a href="/AboutUs/Home">About Us</a>
                    <Show when={submenu() == "About Us"}>
                        <ul class="dropdown right">
                            <li>
                                <a href="/Article/Title/the-philosophy-of-arc">ARC Philosophy</a>
                            </li>
                            <li>
                                <a href="/Article/Search?authorId=26">Chairman Fred Ross's Speeches &amp; Articles</a>
                            </li>
                            <li>
                                <a href="/Article/Search">All Articles</a>
                            </li>
                            <li>
                                <a href="/AboutUs/MissionStatement">Mission Statement</a>
                            </li>
                            <li>
                                <a href="/AlliedOrganization/Search">ARC Allied Organizations</a>
                            </li>
                            <li>
                                <a href="/Gallery/Home">ARC Art Gallery List</a>
                            </li>
                            <li>
                                <a href="/AboutUs/Staff">Staff</a>
                            </li>
                            <li>
                                <a href="/Home/FAQ">Frequently Asked Questions</a>
                            </li>
                            <li>
                                <a href="/Home/PrivacyPolicy">Privacy Policy</a>
                            </li>
                            <li>
                                <a href="/Home/TermsAndConditions">Terms & Conditions</a>
                            </li>
                            <li>
                                <a href="/Home/ContactUs">Contact Us</a>
                            </li>
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setSubmenu("News") } onmouseleave={clear} classList={{ "menu-active": submenu() == "News" }}>
                    <a href="/News/Home">News</a>
                    <Show when={submenu() == "News"}>
                        <ul class="dropdown">
                            <li>
                                <a href="/Blog/Search">
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a href="/Calendar/Search">
                                    Events Calendar
                                </a>
                            </li>
                            <li>
                                <a href="/News/RecentAdditions">
                                    Recent Additions
                                </a>
                            </li>
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setSubmenu("Museum") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Museum" }}>
                    <a href="/Museum/Home">Museum</a>
                    <Show when={submenu() == "Museum"}>
                        <ul class="dropdown">
                            <li>
                                <a href="/Museum/Search">Search ARC Museum</a>
                            </li>
                            <li>
                                <a href="/LivingArtist/Search">ARC Affiliated Artists™</a>
                            </li>
                            <li role="separator" class="divider" style="border-top: 1px solid #efefef;">

                            </li>
                            <li>
                                <a href="/LivingArtistApplication/Introduction">Become an ARC Affiliated Artist™️!</a>
                            </li>
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setSubmenu("Education") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Education" }}>
                    <a href="/Education/Home">Education</a>
                    <Show when={submenu() == "Education"}>
                        <ul class="dropdown">
                            <li>
                                <a href="/Atelier/Search">
                                    Search ARC Approved Schools
                                </a>
                            </li>
                            <li>
                                <a href="/AtelierApplication/Introduction">
                                    Become an ARC Approved School
                                </a>
                            </li>
                            <li role="separator" class="divider" style="border-top: 1px solid #efefef;"></li>
                            <li>
                                <a href="/Library/Search">Library</a>
                            </li>
                            <li>
                                <a href="/ARChive/home">ARChives</a>
                            </li>
                            <li>
                                <a href="/Education/ArtScholarships">
                                    Art Scholarship Listing
                                </a>
                            </li>
                            <li>
                                <a href="/Education/AudioVisual">Videos & Podcasts</a>
                            </li>
                            <li>
                                <a href="/Education/BouguereauBookGrant">Bouguereau Book Grant</a>
                            </li>
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setSubmenu("Competitions") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Competitions" }}>
                    <a href="/Competition/Home">Competitions</a>
                    <Show when={submenu() == "Competitions"}>
                        <ul class="dropdown">
                            <li>
                                <a href="/Salon/Home">ARC Salons"</a>
                            </li>
                            <li>
                                <a href="/Scholarship/Home">ARC Scholarships</a>
                            </li>
                            <li role="separator" class="divider" style="border-top: 1px solid #efefef;"></li>
                            <li>
                                <a href="/arc-salon-application">ARC Salon Application</a>
                            </li>
                            <li>
                                <a href="/arc-scholarship-application">ARC Scholarship Application</a>
                            </li>
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setSubmenu("Store") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Store" }}>
                    <a href="/Store/Home">Store</a>
                    <Show when={submenu() == "Store"}>
                        <ul class="dropdown">
                            <li>
                                <a target="_blank" href="http://www.arc-store.com">Products</a>
                            </li>
                            <li>
                                <a href="/Store/ImageUsage">
                                    Image Usage
                                </a>
                            </li>
                            <li>
                                <a href="/Store/BecomeSponsor">
                                    Become an ARC Sponsor
                                </a>
                            </li>
                            <li>
                                <a href="/Store/PaintingAppraisals">
                                    Painting Appraisals
                                </a>
                            </li>
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setSubmenu("My ARC") } onmouseleave={clear} classList={{ "menu-active": submenu() == "My ARC" }}>
                    <a href="/MyARC/Home/Index">My ARC</a>
                    <Show when={submenu() == "My ARC"}>
                        <ul class="dropdown">
                            <Show when={!session.isLoggedIn}>
                                <li>
                                    <a href={"/Home/Register"}>Sign Up</a>
                                </li>
                            </Show>
                            <Show when={!session.isRegistered}>
                                <li>
                                    <Link href={"/register"}>Join Forum</Link>
                                </li>
                            </Show>
                            <Show when={session.member.memberType == "Free"}>
                                <li>
                                    <a href="/MyARC/Membership/ManageMembership">Subscribe</a>
                                </li>
                            </Show>
                            <Show when={session.member.memberType != "Free"}>
                                <li>
                                    <a href="/MyARC/Membership/ManageMembership">Manage My Membership</a>
                                </li>
                            </Show>
                            <Show when={session.isLoggedIn}>
                                <li>
                                    <a href="/MyARC/Membership/UpdateAccount">Update My Account</a>
                                </li>
                                <li>
                                    <Link href="/register">Update My ARC Forum Profile</Link>
                                </li>
                                <li>
                                    <a href="/MyARC/Membership/ChangePassword">Change My Password</a>
                                </li>
                                <li role="separator" class="divider" style="border-top: 1px solid #efefef;"></li>
                                <li>
                                    <a href="/MyARC/Collection/List">My Albums</a>
                                </li>
                                <li>
                                    <a href="/Museum/Search?onlyShowLikes=true">My Favorite Artists</a>
                                </li>
                                <li>
                                    <a href="/Calendar/Search?showMyEvents=true">My Calendar Events</a>
                                </li>
                            </Show>
                            {/* @if (showPublicPages)
                            {
                                <li role="separator" class="divider" style="border-top: 1px solid #efefef;">

                                </li>
                                if (hasArtist)
                                {
                                    if (ArtistTypeConstants.GetList().Any(x => x.Value == Model.Artist.ArtistType))
                                    {
                                        <li>
                                            <a href="/Artist/Index/@Model.ArtistId">
                                                @await ContentTextAsync("nav", "view-my-gallery-in-the-arc-museum", "View my gallery in the ARC Museum")
                                            </a>
                                        </li>
                                    }
                                }
                                if (hasAtelier)
                                {
                                    var atelierMember = Model.AtelierMembers.FirstOrDefault();
                                    var status = atelierMember.Atelier.ApplicationStatus;
                                    if (status == ApplicationStatusConstants.Accepted.Value)
                                    {
                                        <li>
                                            <a href="/Atelier/Index/@atelierMember.Atelier.Id">
                                                @await ContentTextAsync("nav", "view-my-arc-approved-school", "View my ARC Approved School")
                                            </a>
                                        </li>
                                    }
                                }
                                if (hasOrganization)
                                {
                                    var organizationMember = Model.AffiliatedOrganizationMembers.FirstOrDefault();
                                    <li>
                                        <a href="/AlliedOrganization/Index/@organizationMember.AffiliatedOrganization.Id">
                                            @await ContentTextAsync("nav", "view-my-arc-allied-organization", "View my ARC Allied Organization")
                                        </a>
                                    </li>
                                }
                            }
                            @if (showMyARCAdmin)
                            {
                                <li role="separator" class="divider" style="border-top: 1px solid #efefef;">

                                </li>

                                if (hasArtist)
                                {
                                    var status = Model.Artist.ApplicationStatus;
                                    if (ArtistTypeConstants.GetList().Any(x => x.Value == Model.Artist.ArtistType))
                                    {
                                        <li>
                                            <a href="/MyARC/Artist/Home">
                                                @await ContentBlockAsync("nav", "manage-my-arc-living-artist-gallery", "Manage my ARC Living Artist<sup>&reg;</sup> gallery")
                                            </a>
                                        </li>
                                    }
                                    else if (status == ApplicationStatusConstants.Created.Value)
                                    {
                                        <li>
                                            <a href="/LivingArtist/Step1">
                                                @await ContentBlockAsync("nav", "update-my-arc-living-artist-application", "Update my ARC Living Artist<sup>&reg;</sup> application")
                                            </a>
                                        </li>
                                    }
                                }
                                if (hasAtelier)
                                {
                                    var atelierMember = Model.AtelierMembers.FirstOrDefault();
                                    var status = atelierMember.Atelier.ApplicationStatus;
                                    if (status == ApplicationStatusConstants.Accepted.Value)
                                    {
                                        <li>
                                            <a href="/MyARC/Atelier/Home">
                                                @await ContentTextAsync("nav", "manage-my-atelier", "Manage my atelier")
                                            </a>
                                        </li>
                                    }
                                    else if (status == ApplicationStatusConstants.Created.Value)
                                    {
                                        <li>
                                            <a href="/AtelierApplication/Step1">
                                                @await ContentTextAsync("nav", "update-my-atelier-application", "Update my atelier application")
                                            </a>
                                        </li>
                                    }
                                }
                                if (hasOrganization)
                                {
                                    <li>
                                        <a href="/MyARC/AffiliatedOrganization/Home">@await ContentTextAsync("nav", "manage-my-arc-affiliated-organization", "Manage my ARC Affiliated Organization")</a>
                                    </li>
                                }
                            }
                            @if (isJuror)
                            {
                                <li role="separator" class="divider" style="border-top: 1px solid #efefef;">

                                </li>
                            } */}
                            <Show when={session.isLoggedIn}>
                                <Show when={hasPermission("can-judge-living-artists")}>
                                    <li>
                                        <a href="/LivingArtistJury/Artist/Search">Judge Living Artist Applications</a>
                                    </li>
                                </Show>
                                <Show when={hasPermission("can-judge-ateliers")}>
                                    <li>
                                        <a href="/AtelierJury/Atelier/Search">Judge Atelier Applications</a>
                                    </li>
                                </Show>
                                <Show when={hasPermission("can-judge-scholarships")}>
                                    <li>
                                        <a href="/ScholarshipJury/ScholarshipEntrant/Search">Judge Scholarship Applications</a>
                                    </li>
                                </Show>
                            </Show>
                        </ul>
                    </Show>
                </li>
                <Show when={session.isLoggedIn}>
                    <Show when={hasPermission("canAccessAdmin")}>
                        <li class="right">
                            <a class="btn btn-default" href="/Admin/Dashboard/Index">Admin</a>
                        </li>
                    </Show>
                    <li class="right" onmouseenter={() => setSubmenu("Notifications") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Notifications" }}>
                        <Show when={submenu() == "Notifications"}>
                            <Notifications></Notifications>
                        </Show>
                    </li>
                    <Show when={session.isRegistered}>
                        <li class="right">
                            <span style="margin-left: 20px; color: #fff;">Hello, {session.member.username}</span>
                        </li>
                    </Show>
                    <li class="right">
                        <a href="#" onClick={logoutClicked}>Log Out</a>
                    </li>
                </Show>
                <Show when={!session.isLoggedIn}>
                    <li class="right">
                        <a href="#" onClick={loginClicked}>Log In</a>
                    </li>
                    <Show when={session.isRegistered}>
                        <li class="right">
                            <Link href={"/register"}>Join Forum</Link>
                        </li>
                    </Show>
                </Show>
                <li onmouseenter={() => setSubmenu("Donate") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Donate" }}>
                    <a href="/Donate/Index" class="btn btn-chunky-md btn-chunky-goldenrod" style="border-bottom: unset;">Donate!</a>
                </li>
                <li class="right" style="padding: 8px;">
                    <div style="width: 105px;">
                        <LanguageSelector></LanguageSelector>
                    </div>
                </li>
                <Show when={session.isLoggedIn}>
                    <li onmouseenter={() => setSubmenu("Notifications") } onmouseleave={clear} classList={{ "menu-active": submenu() == "Notifications" }}>
                        <Show when={submenu() == "Notifications"}>
                            <div class="megamenu">
                                <div class="megamenu half-width">
                                    <Notifications></Notifications>
                                </div>
                            </div>
                        </Show>
                    </li>
                </Show>
            </ul>
        </div>
        <Offcanvas show={showLogin()} placement="end" onHide={handleCloseLogin}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Log In</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Login
                    onCancel={onLoginCancel}
                    onSuccess={onLoginSuccess}
                    onRegistrationRequired={onLoginRegistrationRequired}
                />
            </Offcanvas.Body>
        </Offcanvas>
    </div>);
};